<template>
  <div class="competition-questions-wrap">
    <moduleTitle
      title1="赛题参考"
      title2="INTRODUCTION"
      id="competition-questions"
    />
    <div class="questions-title">
      赛题一至五为必答题，参赛团队选择任一题作答
    </div>
    <div class="questions-desc">
      答题包括：源代码+作品介绍，完成后，将源代码上传至百度网盘，并将源代码的百度网盘地址通过邮件形式发送至指定邮箱
    </div>
    <div class="questions-desc">
      作品介绍以视频形式在恒生U+平台社区发布活动帖<span>（详见赛事规则）</span>
    </div>
    <img
      :src="competitionQuestionsImg"
      alt=""
      class="competition-questions-img"
      id="competition-questions1"
    />
  </div>
</template>
<script>
import moduleTitle from './moduleTitle'
export default {
  name: 'BigShot',
  components: { moduleTitle },
  data() {
    return {
      competitionQuestionsImg:
        window.financialCompetitionResource.competitionQuestionsImg
    }
  },
  created() {},
  mounted() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
#competition-questions,
#competition-questions1 {
  opacity: 0;
}
.competition-questions-wrap {
  width: 1200px;
  padding: 64px 0 48px;
  margin: 0 auto;
}
.competition-questions-img {
  width: 1200px;
  height: 729px;
}
.questions-title {
  font-family: AlibabaPuHuiTiM;
  font-size: 18px;
  color: #111;
  text-align: center;
  font-weight: 500;
  line-height: 30px;
}
.questions-desc {
  font-family: AlibabaPuHuiTiR;
  font-size: 14px;
  color: #333;
  text-align: center;
  line-height: 26px;
  font-weight: 400;
  &:last-of-type{
    margin-bottom: 22px;
  }
  span {
    color: #666;
  }
}
</style>


// WEBPACK FOOTER //
// src/gtn/views/financialCompetitionViews/components/competitionQuestions.vue